import vk from 'modules/Services/Access/List/subcomponents/filtersConfigs/vk'
import vkAds from 'modules/Services/Access/List/subcomponents/filtersConfigs/vk-ads'

const map = {
  vk: vk,
  'vk-ads': vkAds,
}

export default map
